import script from "./MainSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSection.vue?vue&type=script&setup=true&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=fc14ad66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc14ad66"]])

export default __exports__